// extracted by mini-css-extract-plugin
export default {"root":"emoji-toolbar-plugin_root__t0usZ"};